// extracted by mini-css-extract-plugin
export default {"banner":"StatusBanner_banner__-nM7S","bannerCompleted":"StatusBanner_bannerCompleted__yV99E"};